module.exports = __webpack_public_path__ + "static/media/next.51b3cafc.svg";